import React, { useEffect } from "react";
import {
  FaInfoCircle,
  FaUserCheck,
  FaClipboardList,
  FaCreditCard,
  FaUndo,
  FaBan,
  FaShieldAlt,
  FaBalanceScale,
  FaDatabase,
  FaCopyright,
  FaUserSlash,
  FaGlobe,
  FaPhoneAlt,
  FaFileContract
} from "react-icons/fa";

export default function TermsConditions() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const terms = [
    {
      icon: <FaInfoCircle size={20} />,
      title: "1. Acceptance of Terms",
      desc: "By accessing or using the MedrphaLab platform, website, or mobile application, you agree to be bound by these Terms & Conditions and all applicable Indian healthcare laws.",
    },
    {
      icon: <FaClipboardList size={20} />,
      title: "2. Nature of Platform",
      desc: "MedrphaLab is a digital healthcare platform facilitating lab test booking, phlebotomy home collection, and report delivery through certified third-party partner laboratories.",
    },
    {
      icon: <FaUserCheck size={20} />,
      title: "3. User Eligibility",
      desc: "You must be at least 18 years of age or possess legal parental consent to book diagnostic services and schedule home collections on our platform.",
    },
    {
      icon: <FaCreditCard size={20} />,
      title: "4. Pricing & Payments",
      desc: "Prices listed on the platform are inclusive of applicable taxes. Payment can be made securely via UPI, Net Banking, Credit/Debit Cards, or Cash On Collection.",
    },
    {
      icon: <FaUndo size={20} />,
      title: "5. Cancellation & Refunds",
      desc: "Cancellations made prior to phlebotomist sample collection are eligible for a 100% instant refund processed within 3 to 7 working days to the original payment method.",
    },
    {
      icon: <FaBan size={20} />,
      title: "6. User Conduct",
      desc: "Users agree to provide accurate medical information, address details, and contact numbers. Misuse, unauthorized scraping, or abusive behavior will lead to termination.",
    },
    {
      icon: <FaShieldAlt size={20} />,
      title: "7. Medical Disclaimer",
      desc: "Diagnostic test reports are provided for informational and clinical aid. They do not substitute professional in-person medical diagnosis, surgery, or prescription treatment.",
    },
    {
      icon: <FaDatabase size={20} />,
      title: "8. Privacy & Data Protection",
      desc: "Patient personal and diagnostic data is protected under highest encryption standards conforming to the Digital Personal Data Protection (DPDP) Act, 2023.",
    },
    {
      icon: <FaBalanceScale size={20} />,
      title: "9. Governing Law & Jurisdiction",
      desc: "These terms and conditions are governed by the laws of India. Any disputes arising shall be subject to the exclusive jurisdiction of the courts in Gautam Buddha Nagar (Noida), U.P.",
    },
  ];

  return (
    <div className="w-full min-h-screen bg-slate-50 text-slate-800">
      
      {/* HERO SECTION */}
      <section className="relative bg-gradient-to-br from-red-600 via-red-700 to-rose-800 text-white py-16 md:py-20 px-4 sm:px-6 lg:px-12 overflow-hidden">
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-white/10 rounded-full blur-3xl pointer-events-none" />
        <div className="absolute -bottom-24 -right-24 w-96 h-96 bg-amber-400/10 rounded-full blur-3xl pointer-events-none" />

        <div className="max-w-4xl mx-auto text-center relative z-10">
          <div className="inline-flex items-center gap-2 bg-white/15 text-white border border-white/20 px-3.5 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-4">
            <FaFileContract className="text-amber-300" />
            <span>Legal Agreement</span>
          </div>
          <h1 className="text-3xl sm:text-5xl font-black tracking-tight text-white leading-tight">
            Terms & Conditions
          </h1>
          <p className="mt-3 text-xs sm:text-sm text-red-100 max-w-2xl mx-auto">
            ARMC PHARMA PRIVATE LIMITED • Effective Date: January 1, 2026
          </p>
        </div>
      </section>

      {/* TERMS GRID */}
      <section className="max-w-6xl mx-auto px-4 sm:px-6 py-12 md:py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {terms.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl p-6 border border-slate-200/80 shadow-xs hover:shadow-lg hover:border-red-200 transition-all duration-300 group"
            >
              <div className="w-12 h-12 rounded-2xl bg-red-50 text-red-600 flex items-center justify-center mb-4 group-hover:bg-red-600 group-hover:text-white transition-all shadow-xs">
                {item.icon}
              </div>
              <h3 className="text-base font-bold text-slate-900 mb-2">
                {item.title}
              </h3>
              <p className="text-xs sm:text-sm text-slate-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>

        {/* SUPPORT NOTE */}
        <div className="mt-10 bg-white rounded-2xl p-6 border border-slate-200 text-center max-w-xl mx-auto">
          <h4 className="text-sm font-bold text-slate-900 mb-1">
            Questions Regarding Our Terms?
          </h4>
          <p className="text-xs text-slate-500 mb-3">
            Contact our legal and customer compliance team anytime.
          </p>
          <div className="inline-flex items-center gap-2 text-xs font-bold text-red-600 bg-red-50 px-4 py-2 rounded-xl">
            <FaPhoneAlt size={11} />
            <span>Support: +91 81783 99885 | info@medrpha.com</span>
          </div>
        </div>
      </section>

    </div>
  );
}
